import { h, Fragment } from "preact";
import { useState, useEffect } from "preact/hooks";
import register from "preact-custom-element";
import useProduct from "../../helpers/useProduct/useProduct";
import MonogramSteps from "./monogram-steps";
import injectFonts from "./inject-fonts";
import MonogramPreview from "./monogram-preview";
import RichText from "../../helpers/richText";
import { positions } from "./constants";
import handleAddToCart from "./handleAddToCart";

function MonogramConfig({ productId, currentVariantId }) {
  const [data] = useProduct(`gid://shopify/Product/${productId}`);
  const [config, setConfig] = useState({});
  const [error, setError] = useState(null);
  const [visibleSteps, setVisibleSteps] = useState(new Array(20).fill(true));

  const configComplete = config.initials?.some((initial) => initial);

  useEffect(() => {
    if (error) {
      setTimeout(() => {
        setError(null);
      }, 4000);
    }
  }, [error]);

  useEffect(() => {
    injectFonts(data);
  }, [data]);

  if (!data) {
    return (
      <div className="monogram-config__loading">
        {window.theme.localeStrings.monogram.loading}
      </div>
    );
  }

  const { product, globalConfig, shop } = data;

  const setVisibleStep = ({ i, visible }) => {
    if (visibleSteps[i] === visible) return;

    const newVisibleSteps = [...visibleSteps];

    newVisibleSteps[i] = visible;

    setVisibleSteps(newVisibleSteps);
  };

  const stepNumberForIndex = (stepIndex) =>
    visibleSteps.reduce((prev, curr, i) => {
      if (i > stepIndex) return prev;

      return prev + (curr ? 1 : 0);
    }, 0);

  const steps = MonogramSteps({
    product,
    globalConfig,
    config,
    setConfig,
    setVisibleStep,
  }).map(({ component, title }, i) => {
    if (!visibleSteps[i]) return component;

    return (
      <div className="monogram-config__step">
        <h3 className="monogram-config__step-title">{`${stepNumberForIndex(i)}. ${title()}`}</h3>
        {component}
      </div>
    );
  });

  return (
    <div className="monogram-config">
      <MonogramPreview
        className="monogram-config__preview-wrapper--desktop"
        product={product}
        globalConfig={globalConfig}
        config={config}
      />
      <div className="monogram-config__drawer">
        <div className="monogram-config__header-wrapper">
          <div className="monogram-config__header">
            {window.theme.localeStrings.monogram.title}
          </div>
          <MonogramPreview
            className="monogram-config__preview-wrapper--mobile"
            product={product}
            globalConfig={globalConfig}
            config={config}
          />
        </div>
        <div className="monogram-config__steps">{steps}</div>
        <div className="monogram-config__footer">
          {product.monogramSettings.disclaimer && (
            <RichText
              className="monogram-config__disclaimer rte--simple rte--no-link-underlines"
              schema={product.monogramSettings.disclaimer}
            />
          )}
          {error && (
            <div
              className="monogram-config__error"
              dangerouslySetInnerHTML={{
                __html: error,
              }}
            ></div>
          )}
          <button
            className="button button--primary button--full"
            disabled={!configComplete}
            data-gtm-action="add_to_cart"
            type="button"
            onClick={() =>
              handleAddToCart({
                product,
                currentVariantId,
                monogramVariant: shop.monogramVariantGid.replace(
                  "gid://shopify/ProductVariant/",
                  "",
                ),
                config,
                setError,
              })
            }
          >
            {window.theme.localeStrings.product.add_monogram}
          </button>
        </div>
      </div>
    </div>
  );
}

if (!customElements.get("monogram-config")) {
  register(
    MonogramConfig,
    "monogram-config",
    ["product-id", "current-variant-id"],
    {
      shadow: false,
    },
  );
}
